module.exports = __webpack_public_path__ + "static/media/FREERIDER-RF-5200-iQ.7ebe299b.png";